import { FR_APPLICATION_STATUSES } from '@/helpers/fundraising';
import { Preloader } from '@/components/Preloader';
import { USER_STATUSES } from '@/helpers/constants';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { useFundraisingStatusById } from '@/hooks/shared/useFundraisingStatusById';
import { useApplicationStatusByFundraisingId } from '@/hooks/shared/useApplicationStatusByFundraisingId';
import { FundraisingGoalStructure } from '../FundraisingGoalStructure';
import { FounderView } from '../FounderView';
import { CoFounderView } from '../CoFounderView';

export const CombinedFundraisingDetail = ({ selectedApplication, onBack }) => {
  const fundraisingId = selectedApplication.fundraising_id;
  const { user, isMainFounder } = useGetMe();
  const { isParticipating } = useFundraisingStatusById(fundraisingId);
  const { application } = useApplicationStatusByFundraisingId(fundraisingId);

  if (!selectedApplication || !user || !application)
    return (
      <div className="container-inner">
        <Preloader style={{ height: '40vh' }} />
      </div>
    );

  if (application.status === null || application.status === FR_APPLICATION_STATUSES.NEW) {
    return <FundraisingGoalStructure selectedApplication={selectedApplication} onBack={onBack} />;
  }

  const disabled =
    user.status !== USER_STATUSES.verified ||
    !isParticipating ||
    application.status !== FR_APPLICATION_STATUSES.APPROVED;

  return isMainFounder ? (
    <FounderView disabled={disabled} fundraisingId={fundraisingId} onBack={onBack} />
  ) : (
    <CoFounderView disabled={disabled} fundraisingId={fundraisingId} onBack={onBack} />
  );
};